import $ from 'jquery'
import { MessageOverlay } from './message-overlay'

$(function watchShowMoreClickOnPanels() {
  $(document).on('click', '.js-panel-more', function showMore(event) {
    event.preventDefault()

    const $el = $(this)
    const $listBody = $el.parents('.js-panel-list-body')

    if ($listBody.length < 1) {
      throw new Error('Missing .js-panel-list-body!')
    }

    $.get($el.attr('href'))
      .done(function (response) {
        $listBody.append(response)
        $el.remove()
      })
      .fail(function () {
        MessageOverlay.show(
          'There was a problem showing more items. Please try again.',
          'error'
        )
      })
  })
})
